/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check the dates — the birth date can't be after the 'age at' date.`)
};

const es_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor verifica las fechas — la fecha de nacimiento no puede ser posterior a la fecha de 'edad en'.`)
};

const de_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte überprüfen Sie die Daten — das Geburtsdatum kann nicht nach dem Datum "Alter am" liegen.`)
};

const nl_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer alstublieft de datums — de geboortedatum kan niet na de 'leeftijd op' datum liggen.`)
};

const fr_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vérifier les dates — la date de naissance ne peut pas être après la date « âge à ».`)
};

const it_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per favore controlla le date — la data di nascita non può essere dopo la data 'età alla data'.`)
};

const pt_br2_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique as datas — a data de nascimento não pode ser posterior à data de 'idade em'.`)
};

const pt_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor verifique as datas — a data de nascimento não pode ser posterior à data de "idade em".`)
};

const ja_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を確認してください。生年月日は「特定の日付での年齢」の日付より後ろにすることはできません。`)
};

const zh_age_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查日期——出生日期不能晚于“计算日期”。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_invalid", locale)
	if (locale === "en") return en_age_invalid(inputs)
	if (locale === "es") return es_age_invalid(inputs)
	if (locale === "de") return de_age_invalid(inputs)
	if (locale === "nl") return nl_age_invalid(inputs)
	if (locale === "fr") return fr_age_invalid(inputs)
	if (locale === "it") return it_age_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_age_invalid(inputs)
	if (locale === "pt") return pt_age_invalid(inputs)
	if (locale === "ja") return ja_age_invalid(inputs)
	return zh_age_invalid(inputs)
};